<script>

    import {checkRule, RULES} from "@/assets/plugins/mps-common/rules/rules";

    export default {
        name: "RulesMixin",
        data() {
            return {
                RULES: RULES,
                checkRule: checkRule,
            }
        }
    }
</script>